export const ADMIN_PRINCIPAL_ID = '00000000-0000-0000-0000-000000000001';
export const EVERYONE_PRINCIPAL_ID = '00000000-0000-0000-0000-000000000002';
export const SSO_GROUPS_KEY_ID = '00000000-0000-0000-0000-000000000003';
export const RESERVED_PRINCIPAL_ID_PREFIX = '00000000-0000-0000-0000-';
/**
 * This regex is strange and unreadable. What it is doing is rejecting all
 * strings that start with `00000000-0000-0000-0000-`. This rejection helps
 * prevent certain UUIDs from being generated on the client side, either by
 * user error or malicious intent. These UUIDs should not be produced by
 * standard UUID generators, as they represent an invalid UUID version.
 *
 * Although specific identifiers are listed above, all UUIDs following
 * the pattern 00000000-0000-0000-0000-xxxxxxxxxxxx will be considered
 * reserved.
 */
export const NON_RESERVED_PRINCIPAL_ID_REGEX = /^(?!0{8}-(?:0{4}-){3})/;
/**
 * Matches reserved principal IDs: 00000000-0000-0000-0000-xxxxxxxxxxxx.
 * These have zeroed version/variant bits and are rejected by strict UUID
 * validators like z.string().uuid(), so they need separate validation.
 */
export const RESERVED_PRINCIPAL_ID_REGEX = /^0{8}-(?:0{4}-){3}[\dA-Fa-f]{12}$/;
